import { Box, DialogContent, DialogTitle, Stack } from "@mui/material";
import { employeeBussiness } from "api/bussiness/employee/employee-bussiness";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateEmployee } from "mobx-stores/_models/employee/employee";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useState } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { XAvatar } from "share-components/x-avatar/x-avatar";
import { employeeFormSchema } from "../schema";

export const EditEmployee = observer(() => {
  const [imageSource, setImageSource] = useState<File | null>(null);

  const {
    setProp: setRootStoreProps,
    inProgress,
    employeeManagement: {
      openEdit,
      setProp,
      employeeDetail,
      getEmployeeDetail,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
    setDefaults,
  } = useForm<IUpdateEmployee>(employeeFormSchema(), {
    code: employeeDetail?.code || "",
    fullName: employeeDetail?.fullName || "",
    branch: employeeDetail?.branch || "",
    departmentTypeId: employeeDetail?.departmentTypeId || "",
    position: employeeDetail?.position || "",
    gender: employeeDetail?.gender,
    level: employeeDetail?.level || "",
    qualification: employeeDetail?.qualification || "",
    id: employeeDetail?.id || "",
    note: employeeDetail?.note || "",
  });

  useEffect(() => {
    if (employeeDetail) {
      setDefaults({
        code: employeeDetail?.code || "",
        fullName: employeeDetail?.fullName || "",
        branch: employeeDetail?.branch || "",
        departmentTypeId: employeeDetail?.departmentTypeId || "",
        position: employeeDetail?.position || "",
        gender: employeeDetail?.gender,
        level: employeeDetail?.level || "",
        qualification: employeeDetail?.qualification || "",
        id: employeeDetail?.id || "",
        note: employeeDetail?.note || "",
      });
    }
  }, [getControl, setDefaults, employeeDetail]);

  const fetchDepartmentType = useCallback(async () => {
    const departmentTypeCtr = getControl("departmentTypeId");
    const res = await departmentTypeCtr?.metaData?.searchOptionItemsAsync?.("");
    departmentTypeCtr?.setProp("optionItems", res);
  }, [getControl]);

  const fetchGender = useCallback(async () => {
    const ctr = getControl("gender");
    const res = await ctr?.metaData?.searchOptionItemsAsync?.("");
    ctr?.setProp("optionItems", res);
  }, [getControl]);

  const fetchAvatar = useCallback(async () => {
    if (employeeDetail?.avatar?.name) {
      const res = await employeeBussiness.getAvatar(
        employeeDetail?.avatar?.name
      );
      setImageSource(res);
    }
  }, [employeeDetail?.avatar?.name]);

  const initData = useCallback(async () => {
    try {
      setRootStoreProps("inProgress", true);
      await fetchDepartmentType();
      await fetchGender();
      await fetchAvatar();
    } catch (error) {
      console.error("Fail initData", error);
    } finally {
      setRootStoreProps("inProgress", false);
    }
  }, [fetchAvatar, fetchDepartmentType, fetchGender, setRootStoreProps]);

  useEffect(() => {
    initData();
  }, [initData]);

  const saveHandler = useCallback(
    async (data: IUpdateEmployee) => {
      if (!employeeDetail?.id) return;
      // const avatar = imageSource ? await fileToBinaryString(imageSource) : "";

      await employeeBussiness.updateEmployeeAsForm(
        employeeDetail?.id,
        data,
        imageSource
      );
      await getEmployeeDetail(employeeDetail?.id);
      setProp("openEdit", false);
    },
    [employeeDetail?.id, imageSource, getEmployeeDetail, setProp]
  );

  const handleChangeSource = (selectedFile: File) => {
    setImageSource(selectedFile);
  };

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid || inProgress,
      }}
    >
      <DialogTitle>Sửa nhân viên</DialogTitle>
      <DialogContent>
        <Stack
          direction={"row"}
          justifyContent={"center"}
          sx={{ padding: "10px" }}
        >
          <XAvatar
            src={imageSource || ""}
            alt="Avatar"
            onChange={handleChangeSource}
          />
        </Stack>
        <Box sx={{ marginTop: "15px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
